// 3D Model constants for TSSOP packages
export const tssopPinMarkerSize = 0.00028; // Slightly smaller than SSOP
export const tssopPinMarkerOffset = (packageSizeX, packageSizeY) => (Math.log10(10 + Math.min(packageSizeX, packageSizeY) * 5000) - 1) / 520;
export const tssopPinMarkerOffsetZ = 0.000001;
export const tssopPinMarkerSegments = 32;
//# sourceMappingURL=tssopConstants.js.map